import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/hooks/use-auth-compat';
import {
  fetchEmailPreferences,
  updateEmailPreferences,
  type EmailPreferences,
} from '@/services/inquiryService';

export function useEmailPreferences() {
  const auth = useAuth();
  const token = auth.user?.access_token ?? '';

  return useQuery({
    queryKey: ['emailPreferences'],
    queryFn: () => fetchEmailPreferences(token),
    enabled: !!token,
    staleTime: 5 * 60 * 1000,
  });
}

export function useUpdateEmailPreferences() {
  const auth = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (prefs: EmailPreferences) => {
      const token = await auth.getToken();
      return updateEmailPreferences(token, prefs);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['emailPreferences'] });
    },
  });
}
